import React from 'react';
import { Star, BadgeCheck } from 'lucide-react';
export function HeroSection() {
  return <header className="mb-8" data-id="element-468">
      {/* Breadcrumb */}
      <nav className="text-sm text-gray-500 mb-4" data-id="element-469">
        <span className="hover:underline cursor-pointer" data-id="element-470">Home</span>
        <span className="mx-1" data-id="element-471">&gt;</span>
        <span className="hover:underline cursor-pointer" data-id="element-472">Women's Health</span>
        <span className="mx-1" data-id="element-473">&gt;</span>
        <span className="text-gray-700" data-id="element-474">Lymphatic Support</span>
      </nav>

      {/* Main Headline */}
      <h1 className="advertorial-headline text-3xl md:text-[40px] text-gray-900 mb-5 leading-tight" data-id="element-475">
        If Your Upper Body Keeps Getting Thinner But Your Legs Stay Exactly the
        Same...{' '}
        <span className="bg-yellow-200/80 px-1 decoration-[#21afa1] decoration-[3px]" data-id="element-476">
          A Lymphatic Specialist Explains What Doctors Aren't Telling You About
          Lipedema
        </span>
      </h1>

      {/* Rating */}
      <div className="flex items-center gap-3 mb-6" data-id="element-477">
        <div className="flex text-yellow-500" data-id="element-478">
          <Star className="w-5 h-5 fill-current" data-id="element-479" />
          <Star className="w-5 h-5 fill-current" data-id="element-480" />
          <Star className="w-5 h-5 fill-current" data-id="element-481" />
          <Star className="w-5 h-5 fill-current" data-id="element-482" />
          <Star className="w-5 h-5 fill-current" data-id="element-483" />
        </div>
        <span className="text-gray-700 font-medium" data-id="element-484">4.8 out of 5</span>
        <span className="text-[#21afa1] font-semibold" data-id="element-485">4,127 Ratings</span>
      </div>

      {/* Author Section */}
      <div className="flex items-start gap-3 mb-8 pb-6 border-b border-gray-200" data-id="element-486">
        {/* Author Photo - Dr. Maria Castellanos */}
        <img src="https://cdn.magicpatterns.com/uploads/h6aJiR4XXiJRW5ri8NK5g7/ChatGPT_Image_5_Φεβ_2026,_04_04_25_μ.μ..png" alt="Dr. Maria Castellanos" className="w-12 h-12 rounded-full object-cover border-2 border-gray-200 flex-shrink-0" data-id="element-487" />
        <div className="flex-1" data-id="element-488">
          <div className="flex items-center gap-2" data-id="element-489">
            <span className="font-semibold text-gray-900" data-id="element-490">
              By Dr. Maria Castellanos
            </span>
            <BadgeCheck className="w-5 h-5 text-[#21afa1] fill-[#21afa1]" data-id="element-491" />
          </div>
          <p className="text-sm text-gray-600" data-id="element-492">
            Lymphatic Health Specialist & Vascular Wellness Expert | February 5,
            2026 | 8:42 am EST
          </p>
        </div>
      </div>

      {/* Hero Image */}
      <div className="relative w-full rounded-lg overflow-hidden mb-8" data-id="element-493">
        <img src="https://cdn.magicpatterns.com/uploads/oqmSDpoJG3DtCjkwJovn9L/ChatGPT_Image_5_Φεβ_2026,_03_59_23_μ.μ..png" alt="Woman experiencing leg discomfort while sitting on couch" className="w-full h-auto object-cover" data-id="element-494" />
      </div>
    </header>;
}